import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import { SEND_REQUEST_REORDER_EMAIL_FOR_SUPPLIER } from '../constants/reorder';

const initialState = {
  reorder_email_sent_for_suppliers: [],
};

const supplierReorderRequest = (state = initialState, action) => {
  switch (action.type) {
    case SEND_REQUEST_REORDER_EMAIL_FOR_SUPPLIER:
      return {
        ...state,
        reorder_email_sent_for_suppliers: [...state.reorder_email_sent_for_suppliers, action.payload],
      };
    default:
      break;
  }
  return state;
};

const persistConfig = {
  key: 'supplierReorderRequest',
  storage: storage,
};

export default persistReducer(persistConfig, supplierReorderRequest);
